<template>
  <div class="resizable-container">
    <!-- 左侧可拖动区域 -->
    <div class="left-panel" :style="{ width: leftWidth + 'px' }">


      <el-tree style="height: 96%;overflow: auto;" ref="treeRef" node-key="pftr01" :data="treedata" highlight-current
        :props="defaultProps" @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;" src="@/assets/img/图标/folder.svg" />
          <span class="node-label">{{ data.pftr02 }}</span>
        </span>

      </el-tree>

    </div>

    <!-- 拖动手柄 -->
    <div class="resizer" @mousedown="startDrag" :class="{ 'active': isDragging }">
      <div class="resizer-handle"></div>
    </div>

    <!-- 右侧区域 -->
    <div class="right-panel">
      <el-container>
        <el-header>
          <el-row style="padding: 20px 0;">
            <el-col :span="16">
              <el-radio-group v-model="listType" size="mini" style="margin-left: 5px;">
                <el-radio-button label="列表">{{ $t('我的资料.列表') }}</el-radio-button>
                <el-radio-button label="宫格">{{ $t('我的资料.宫格') }}</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="8" style="text-align: right;">
              <el-popover placement="left" width="300" trigger="click">
                <el-row>
                  <el-col :span="12">
                    <div style="display: flex; flex-direction: column; align-items: center; ">
                      <el-switch v-model="gml" active-color="green" @change="GetDataFileList"></el-switch>
                      <span :style="{ color: gml ? 'green' : '#dcdfe6' }">{{ $t('xmzl.根目录') }}</span>
                    </div>
                  </el-col>
                  <el-col :span="10" :offset="2">
                    <el-select v-model="fileext" @change="GetDataFileList" multiple filterable allow-create clearable
                      collapse-tags :placeholder="$t('xmzl.请选择文件类型')">
                      <el-option v-for="item in modelexts.concat(exts)" :key="item" :label="item"
                        :value="item"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-cascader v-model="labelval" @change="GetDataFileList" :options="filelabelData"
                      :placeholder="$t('xmzl.请选择标签')"
                      :props="{ multiple: true, label: 'name', value: 'name', expandTrigger: 'hover' }" collapse-tags
                      clearable></el-cascader>
                  </el-col>
                  <el-col :span="10" :offset="2">
                    <el-select filterable v-model="value" @change="selectChange">
                      <el-option :label="$t('xmzl.全部')" value="1"></el-option>
                      <el-option :label="$t('xmzl.我上传的')" value="3"></el-option>
                      <el-option :label="$t('xmzl.我收藏的')" value="2"></el-option>
                    </el-select>
                  </el-col>
                </el-row>

                <el-button slot="reference" style="margin: 0 5px;" icon="el-icon-search" size="mini" type="primary">{{
                  $t('我的资料.高级查询')
                }}</el-button>
              </el-popover>


              <el-input size="mini" :placeholder="$t('我的资料.请输入文件名称关键词')" v-model="searchword" @input="searchChange"
                style="width: 40%;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <p style="margin: -30px 0 10px 0;width: 94%;display: inline-block;">
            <el-button type="text" @click="home()" class="el-icon-s-home"
              style="margin-right: 5px;font-size: 16px;"></el-button>
            <el-button type="text" :style="{
              fontWeight: selectNode.pftr01 == item.pftr01 ? 'bold' : 'normal',
              margin: 0,
              fontSize: '15px',
              color: selectNode.pftr01 == item.pftr01 ? 'black' : 'rgb(0, 53, 101)'
            }" v-for="(item, index) in breadcrumbData" @click="breadcrumbClick(item)" :key="index">{{ (index ==
              breadcrumbData.length - 1) ? item.pftr02 :
              item.pftr02 + "/" }}</el-button>
          </p>
          <el-dropdown>
            <el-button size="mini">
              <span v-html="currentSort.label"></span>
            </el-button>

            <el-dropdown-menu>
              <!-- 遍历数据列表 -->
              <el-dropdown-item v-for="(item, index) in sortOptions" :key="index" @click.native="handleSort(item)">
                <!-- 使用 #default 插槽渲染 HTML -->
                <template #default>
                  <span v-html="item.label"></span>
                </template>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 数据列表 -->
          <div class="rygl-table" v-show="listType == '列表'">
            <el-table ref="multipleTable" header-row-class-name="headerClass" highlight-current-row
              :data="fileTableData" tooltip-effect="dark" height="60vh" @selection-change="SelectionChange"
              @select-all="handleSelectAll" v-loading="tableLoading">
              <el-table-column align="center" type="selection" :selectable="checkSelectable"></el-table-column>
              <el-table-column prop="name" :label="$t('我的资料.文件名称')">
                <template slot-scope="scope">
                  <div v-if="scope.row.isFolder">
                    <el-button type="text"
                      style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 20px;text-align: left;"
                      @click="breadcrumbClick(scope.row)">
                      <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;" src="@/assets/img/图标/folder.svg" />
                      {{ scope.row.pftr02 }}
                    </el-button>
                  </div>
                  <div v-else>
                    <div v-if="exts.indexOf(scope.row.ext) > -1">
                      <!-- <el-tooltip effect="dark" :content="scope.row.prfl02" placement="bottom-start"> -->
                      <el-button type="text" @click="documentOpen(scope.row)"
                        style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 20px;text-align: left;">
                        <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;"
                          :src="documentIcon(scope.row.ext)" />{{
                            scope.row.prfl02 }}
                      </el-button>
                      <!-- </el-tooltip> -->
                    </div>
                    <div style="display: flex; align-items: center; width: 100%; white-space: nowrap;"
                      v-else-if="modelexts.indexOf(scope.row.ext) > -1">
                      <i v-if="scope.row.modelstate == 1 || scope.row.modelstate == null" class="el-icon-view"
                        :title="$t('我的资料.点击转换')"
                        :style="{ marginRight: '8px', cursor: 'pointer', color: scope.row.modelstate == 1 ? 'red' : 'black' }"
                        @click="transformfilemodel(scope.row)"></i>
                      <i v-if="scope.row.modelstate == 0" class="el-icon-loading" :title="$t('我的资料.转换中请稍等')"></i>
                      <el-button type="text" @click="documentOpen(scope.row)"
                        style="flex: 1; overflow: hidden; text-overflow: ellipsis;text-align: left;">
                        <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;"
                          :src="documentIcon(scope.row.ext)" />
                        {{ scope.row.prfl02 }}
                        <span :style="{
                          color:
                            scope.row.modelstate == 0
                              ? '#e6a23c'
                              : scope.row.modelstate == 1
                                ? '#f56c6c'
                                : scope.row.modelstate == 2
                                  ? '#67c23a'
                                  : 'black',
                        }">
                        </span>
                      </el-button>
                      <!-- </el-tooltip> -->
                    </div>
                    <span v-else>
                      <el-button type="text"
                        style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: left;cursor:text">
                        <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;"
                          :src="documentIcon(scope.row.ext)" />
                        {{ scope.row.prfl02 }}
                      </el-button>


                    </span>
                  </div>

                </template>
              </el-table-column>
              <el-table-column align="center" width="100" prop="MB" :label="$t('我的资料.文件大小')"></el-table-column>
              <el-table-column align="center" prop="labelval" width="100" :label="$t('xmzl.标签')">
                <template slot-scope="scope">
                  {{ scope.row.prfl02 ? scope.row.labelval : "--" }}
                </template>
              </el-table-column>
              <el-table-column align="center" width="100" :label="$t('我的资料.修改人')">
                <template slot-scope="scope">
                  {{ scope.row.user04 || scope.row.username }}
                </template>

              </el-table-column>

              <el-table-column align="center" width="150" prop="creteTime" :label="$t('我的资料.更新时间')">
                <template slot-scope="scope">
                  {{ scope.row.pftr05 || scope.row.prfl12 }}
                </template>
              </el-table-column>

            </el-table>
          </div>
          <!-- 数据宫格 -->
          <div class="rygl-table" v-show="listType == '宫格'">
            <el-row>
              <el-col :span="3" v-for="(item, index) in fileTableData" :key="index">
                <el-card class="box-card" style="margin: 5px 5px 5px 0px;">
                  <div v-if="item.isFolder" style="height: 100px;width: 100%;text-align: center;">
                    <el-button type="text"
                      style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: center;"
                      @click="breadcrumbClick(item)">
                      <img style="width: 80px; height: 80px;margin: -5px auto 5px auto;display: block;"
                        src="@/assets/img/图标/folder.svg" />
                      {{ item.pftr02 }}
                    </el-button>
                  </div>
                  <div v-else style="height: 100px;width: 100%;">
                    <div v-if="exts.indexOf(item.ext) > -1">
                      <el-button type="text" @click="documentOpen(item)"
                        style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: center;">
                        <img style="width: 80px; height: 80px;margin: -5px auto 5px auto;display: block;"
                          :src="documentIcon2(item)"
                          @mouseenter="(e) => showBigImg(e, $store.state.baseUrl + item.prfl04)"
                          @mouseleave="hideBigImg" alt="缩略图" />

                        {{ item.prfl02 }}
                      </el-button>
                    </div>
                    <div style="display: flex; align-items: center; width: 100%; white-space: nowrap;"
                      v-else-if="modelexts.indexOf(item.ext) > -1">

                      <el-button type="text" @click="documentOpen(item)"
                        style="flex: 1; overflow: hidden; text-overflow: ellipsis;text-align: center;">
                        <img style="width: 80px; height: 80px;margin: -5px auto 5px auto;display: block;"
                          :src="documentIcon2(item)" />
                        <i v-if="item.modelstate == 1 || item.modelstate == null" class="el-icon-view"
                          :title="$t('我的资料.点击转换')"
                          :style="{ marginRight: '0px', cursor: 'pointer', color: item.modelstate == 1 ? 'red' : 'black' }"
                          @click="transformfilemodel(item)"></i>
                        <i v-if="item.modelstate == 0" class="el-icon-loading" :title="$t('我的资料.转换中请稍等')"></i>
                        {{ item.prfl02 }}
                        <span :style="{
                          color:
                            item.modelstate == 0
                              ? '#e6a23c'
                              : item.modelstate == 1
                                ? '#f56c6c'
                                : item.modelstate == 2
                                  ? '#67c23a'
                                  : 'black',
                        }">
                        </span>
                      </el-button>
                    </div>
                    <div v-else style="height: 100px;width: 100%;">
                      <el-button type="text"
                        style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: center;cursor:text">
                        <img style="width: 80px; height: 80px;margin: -5px auto 5px auto;display: block;"
                          :src="documentIcon2(item)" />

                        {{ item.prfl02 }}
                      </el-button>


                    </div>
                  </div>

                  <p style="text-align: center;">
                    <el-button v-if="!item.isFolder"
                      :icon="item.Collection == true ? 'el-icon-star-on' : 'el-icon-star-off'" size="small" type="text"
                      style="cursor: pointer" @click="CollectionFile2(item)"></el-button>

                    <el-popover placement="bottom" width="400" trigger="click">

                      <div style="display: flex;">
                        <el-input v-model="item.editname"></el-input>
                        <el-button type="primary" style="margin-left:10px;" @click="editname(item, 'G' + index)">{{
                          $t('common.确定') }}</el-button>
                        <el-button @click="() => {
                          item.editname = item.pftr02 || item.prfl02
                          $refs['editButtonG' + index][0].$el.click()
                        }">{{ $t('common.取消') }}</el-button>
                      </div>
                      <el-button size="small" type="text" style="cursor: pointer" :ref="'editButtonG' + index"
                        icon="el-icon-edit" slot="reference"></el-button>

                    </el-popover>


                    <el-button size="small" type="text" style="cursor: pointer" icon="el-icon-download"
                      @click="download(item)"></el-button>
                  </p>


                </el-card>
              </el-col>
            </el-row>
          </div>

          <!-- 全局唯一的大图预览层 -->
          <img v-show="showPreview" class="big-img" :src="bigImgSrc" :style="{ left: imgX + 'px', top: imgY + 'px' }"
            ref="bigImg" alt="大图">


        </el-main>
      </el-container>
    </div>
  </div>

</template>

<script>
import {
  GetProjectFileZTree,
  GetDataFileList,
  transformfilemodel,
  AddRecentlyFile,
  GetFileLabel,
} from "@/setAxios.js";
import MyDialog from "@/components/Customization/dialog/index";
import dayjs from "dayjs";


export default {
  name: 'dataList',
  components: { MyDialog },
  data() {
    return {
      listType: '列表',
      //#region 拖拽上传
      uploadTips: false,
      cacheFiles: [],
      //#endregion
      //#region 拖动相关变量

      leftWidth: 200, // 左侧初始宽度
      isDragging: false, // 是否正在拖动
      startX: 0, // 拖动开始时的鼠标X坐标
      startWidth: 0, // 拖动开始时的左侧宽度
      rafId: null, // requestAnimationFrame ID
      minWidth: 200, // 最小宽度
      //#endregion
      //#region 
      searchword: '',
      treedata: [],
      selectNode: {},
      selectNode2: {},
      defaultProps: {
        children: 'children',
        label: 'pftr02',
        value: 'pftr01'
      },
      fileAllTableData: [],
      fileTableData: [],
      //面包屑数据
      breadcrumbData: [],
      //文件夹数据
      folderData: [],
      //标签
      labelval: [],
      //根目录
      gml: false,
      //文件审核状态
      filestate: "",
      //文件类型
      fileext: [],
      //文件标签数据
      filelabelData: [],
      //当前文件
      datafile: {},
      documentList: [],
      tableLoading: false,
      importHeaders: { token: localStorage.getItem("token") },
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: 1,
        ids: "",
        gid: 0,
        qid: localStorage.getItem("pid"),
        labelval: "",
        labelval2: []
      },
      fileList: [],
      uploadingFiles: [], // 存储正在上传的文件进度
      actionUrl: this.$store.state.baseUrl + "/api/UploadDataFile",
      uploadingFiles: [],
      dialogVisible: false,
      dialogVisible2: false,
      initPosition: { x: window.innerWidth - 520, y: window.innerHeight - 370 },
      exts: [
        "png",
        "jpg",
        "jpeg",
        "gif",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "txt",
        "pdf",
      ],
      modelexts: [
        "nwd", "nwf", "nwc",
        "rvt", "rfa",
        "model", "session", "exp", "dlw3", "catpart", "catproduct", "cgr",
        "dgn", "prp", "prw",
        "dwg", "dxf",
        "fbx", "ifc", "3dm", "skp",
        "prt", "sldprt", "asm", "sldasm"
      ],
      selectList: [],
      selectList2: [],
      value: "1",
      uploadShow: false,
      uploadFileShow: false,
      allTreeData: [],
      allFileData: [],
      hszdrawer: false,
      hszData: [],
      activeName: "first",
      sortOptions: [
        { name: '名称降序', label: `${this.$t('排序.名称')} <i class='el-icon-bottom' style='color:red'></i>` },
        { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
        { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
        { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
      ],
      currentSort: { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
      //#endregion

      showPreview: false, // 是否显示大图
      bigImgSrc: '',      // 大图地址
      imgX: 0,            // 大图x坐标
      imgY: 0,            // 大图y坐标

      selectedRow: null,  // 当前选中行
    };
  },
  computed: {
    rightWidth() {
      return window.innerWidth - this.leftWidth - 30; // 减去容器边距和分隔条宽度
    }
  },
  created() {
    this.GetProjectFileZTree();
    this.GetFileLabel()
  },
  methods: {
    handleSelectAll(selection) {
      if (selection.length > 0) {
        // 清空所有选择
        this.$refs.multipleTable.clearSelection()

        // 选中第一个
        if (this.fileTableData.length > 0) {
          this.$nextTick(() => {
            this.$refs.multipleTable.toggleRowSelection(this.fileTableData[0], true)
          })
        }
      }
    },
    checkSelectable(row, index) {
      // 如果没有选中任何行，所有行都可选
      if (row.isFolder)
        return false;
      // if (!this.selectedRow) return true
      if (this.selectedRow && row.prfl01)
        return row.prfl01 == this.selectedRow.prfl01
      return true
    },

    SelectionChange(selection) {
      if (selection.length === 0) {
        // 取消选中
        this.selectedRow = null
      } else {
        // 选中一行（总是取最后一个）
        this.selectedRow = selection[selection.length - 1]
      }
      this.$emit('selectData', this.selectedRow)
    },






    // 显示大图：核心逻辑（获取鼠标位置 + 设置大图地址）
    showBigImg(e, bigSrc) {
      //获取文件后缀
      const fileExt = bigSrc.split('.').pop().toLowerCase();
      //只有图片才显示大图
      if (['png', 'jpg', 'jpeg', 'gif', 'svg', 'ico'].includes(fileExt)) {

        // 重置状态，避免重复加载导致的频闪
        this.showPreview = false;
        this.isImgLoaded = false;

        const mouseX = e.clientX;
        const mouseY = e.clientY;
        const winW = window.innerWidth;
        const winH = window.innerHeight;
        // 预设大图尺寸（直接用最大限制值，无需等加载后修正）
        const previewW = 500;
        const previewH = 400;

        // 一次性计算最终位置（不再加载后修正）
        let x = mouseX + 10;
        let y = mouseY + 10;
        // 边缘适配：左侧/上侧兜底
        x = x + previewW > winW ? mouseX - previewW - 10 : x;
        y = y + previewH > winH ? mouseY - previewH - 10 : y;
        // 防止坐标为负
        this.imgX = Math.max(10, x);
        this.imgY = Math.max(10, y);

        // 赋值并显示（一次性完成，无后续调整）
        this.bigImgSrc = bigSrc;
        this.showPreview = true;
      }
    },
    // 隐藏大图
    hideBigImg() {
      this.showPreview = false;
    },
    //#region 排序相关方法
    handleSort(item) {
      this.currentSort = item;
      if (item.name == '名称升序') {
        this.sortOptions = [
          { name: '名称降序', label: `${this.$t('排序.名称')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '名称降序') {
        this.sortOptions = [
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '时间升序') {
        this.sortOptions = [
          { name: '时间降序', label: `${this.$t('排序.时间')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '时间降序') {
        this.sortOptions = [
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '类型升序') {
        this.sortOptions = [
          { name: '类型降序', label: `${this.$t('排序.类型')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '类型降序') {
        this.sortOptions = [
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '大小升序') {
        this.sortOptions = [
          { name: '大小降序', label: `${this.$t('排序.大小')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '大小降序') {
        this.sortOptions = [
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
        ]
      }
      this.handelSort()
    },
    //执行排序
    handelSort() {
      var folderData = this.fileTableData.filter(item => item.isFolder);
      var fileData = this.fileTableData.filter(item => !item.isFolder);
      if (this.currentSort.name == '名称升序') {
        folderData = this.nameSortMethod(folderData, 'ascending');
        fileData = this.nameSortMethod(fileData, 'ascending');
      } else if (this.currentSort.name == '名称降序') {
        folderData = this.nameSortMethod(folderData, 'descending');
        fileData = this.nameSortMethod(fileData, 'descending');
      } else if (this.currentSort.name == '时间升序') {
        folderData = this.sortArrayByTime(folderData, 'pftr05', 'ascending');
        fileData = this.sortArrayByTime(fileData, 'prfl12', 'ascending');
      } else if (this.currentSort.name == '时间降序') {
        folderData = this.sortArrayByTime(folderData, 'pftr05', 'descending');
        fileData = this.sortArrayByTime(fileData, 'prfl12', 'descending');
      } else if (this.currentSort.name == '类型升序') {
        // folderData = this.extSortMethod(folderData, 'ascending');
        fileData = this.extSortMethod(fileData, 'ascending');
      } else if (this.currentSort.name == '类型降序') {
        // folderData = this.extSortMethod(folderData, 'descending');
        fileData = this.extSortMethod(fileData, 'descending');
      } else if (this.currentSort.name == '大小升序') {
        fileData = this.numberSortMethod(fileData, 'prfl09', 'ascending');
      } else if (this.currentSort.name == '大小降序') {
        fileData = this.numberSortMethod(fileData, 'prfl09', 'descending');
      }

      this.fileTableData = [...folderData, ...fileData]
    },


    //文件类型排序
    extSortMethod(data, order, fieldConfig = {}) {
      const { nameField1 = 'prfl02', nameField2 = 'pftr02' } = fieldConfig;

      // 创建排序比较器
      const collator = new Intl.Collator('zh-CN', {
        numeric: true,
        sensitivity: 'base',
        caseFirst: 'lower',
        usage: 'sort'
      });

      // 提取主名（忽略后缀）
      const getBaseName = (item) => {
        const name = item[nameField1] || item[nameField2] || '';
        if (!name) return '';

        const lastDotIndex = name.lastIndexOf('.');
        if (lastDotIndex > 0 && lastDotIndex < name.length - 1) {
          return name.slice(lastDotIndex);
        }
        return name;
      };

      // 复制数组并排序
      return [...data].sort((a, b) => {
        const baseA = getBaseName(a);
        const baseB = getBaseName(b);
        let compare = collator.compare(baseA, baseB);
        return order === 'ascending' ? compare : -compare;
      });
    },

    // 文件大小排序
    numberSortMethod(arr, orderKey, order) {
      const newArr = [...arr];
      return newArr.sort((a, b) => {
        // 容错：处理时间字段为空/无效的情况，默认排到最后
        const timeA = a[orderKey] || 0;
        const timeB = b[orderKey] || 0;

        return order === 'descending' ? (timeB - timeA) : (timeA - timeB);
      });

    },
    //时间排序
    sortArrayByTime(arr, timeKey, order) {
      // 浅拷贝原数组，避免修改原数据
      console.log(arr);
      const newArr = [...arr];
      return newArr.sort((a, b) => {
        // 容错：处理时间字段为空/无效的情况，默认排到最后
        const timeA = a[timeKey] ? new Date(a[timeKey]).getTime() : 0;
        const timeB = b[timeKey] ? new Date(b[timeKey]).getTime() : 0;

        return order === 'descending' ? (timeB - timeA) : (timeA - timeB);
      });
    },

    /**
     * 按照Windows 11规则排序对象数组（忽略文件后缀）
     * @param {Array} data - 要排序的对象数组
     * @param {string} order - 排序方向：'ascending' 或 'descending'
     * @param {Object} fieldConfig - 字段配置（可选）
     * @param {string} fieldConfig.nameField1 - 第一个名字字段名，默认 'prfl02'
     * @param {string} fieldConfig.nameField2 - 第二个名字字段名，默认 'pftr02'
     * @returns {Array} - 排序后的新数组
     */
    nameSortMethod(data, order, fieldConfig = {}) {
      const { nameField1 = 'prfl02', nameField2 = 'pftr02' } = fieldConfig;

      // 创建排序比较器
      const collator = new Intl.Collator('zh-CN', {
        numeric: true,
        sensitivity: 'base',
        caseFirst: 'lower',
        usage: 'sort'
      });

      // 提取主名（忽略后缀）
      const getBaseName = (item) => {
        const name = item[nameField1] || item[nameField2] || '';
        if (!name) return '';

        const lastDotIndex = name.lastIndexOf('.');
        if (lastDotIndex > 0 && lastDotIndex < name.length - 1) {
          return name.slice(0, lastDotIndex);
        }
        return name;
      };

      // 复制数组并排序
      return [...data].sort((a, b) => {
        const baseA = getBaseName(a);
        const baseB = getBaseName(b);
        let compare = collator.compare(baseA, baseB);
        return order === 'ascending' ? compare : -compare;
      });
    },

    //#endregion



    //#region left content
    searchChange() {
      if (this.searchword != '')
        this.fileTableData = this.fileAllTableData.filter(item => (item.pftr02 && item.pftr02.includes(this.searchword)) || (item.prfl02 && item.prfl02.includes(this.searchword)))
      else
        this.fileTableData = this.fileAllTableData
    },
    breadcrumbClick(data) {
      this.aaa.ids = data.pftr01;
      this.aaa.gid = data.pftr01;
      var treeNode = this.$refs.treeRef.getNode(data.pftr01);
      this.handleNodeClick(data, treeNode)
      this.$refs.treeRef.setCurrentKey(data.pftr01);

      // 展开当前节点
      treeNode.expanded = true;

      // 递归展开所有父节点
      let parent = treeNode.parent;
      while (parent && parent.level > 0) { // 排除根节点
        parent.expanded = true;
        parent = parent.parent;
      }

    },
    // 自定义方法：获取节点的完整路径
    getNodePath(node) {
      const path = [];
      let current = node;

      while (current && current.data) {
        path.unshift(current.data);
        // 关键修复：检查是否是真正的根节点，避免重复
        if (current.parent && current.parent.level === 0) {
          break; // 遇到树根就停止
        }
        current = current.parent;
      }

      return path;
    },
    home() {
      this.selectNode = {};
      this.breadcrumbData = [];
      this.folderData = this.treedata
      this.$refs.treeRef.setCurrentKey();
      this.GetDataFileList();
    },
    GetProjectFileZTree() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileZTree({ params }).then(res => {
        if (res.Data.length) {
          res.Data.forEach(v => {
            v.isFolder = true;
            v.editname = v.pftr02
          })
          this.allTreeData = JSON.parse(JSON.stringify(res.Data));
          res.Data = res.Data.filter(w => w.isHide == 0);
          res.Data = this.nameSortMethod(res.Data, 'ascending', { nameField1: 'pftr02', nameField2: 'prfl02' });
          this.treedata = this.buildTree(res.Data, "pftr01", "pftr03");
          this.folderData = this.treedata;
          if (this.selectNode.pftr01) {
            this.$nextTick(() => {
              this.breadcrumbClick(this.selectNode)
            });
          } else {
            this.GetDataFileList();
          }
        }
      })
    },

    handleNodeClick(data, node) {
      this.aaa.ids = data.pftr01;
      this.aaa.gid = data.pftr01;
      this.selectNode = data;
      this.aaa.treeId = data.id;
      this.breadcrumbData = [];
      this.breadcrumbData = this.getNodePath(node);
      this.folderData = node.childNodes.map(item => item.data);
      this.GetDataFileList();
    },

    handleNodeClick2(data) {
      this.selectNode2 = data;
    },

    /**
     * 将扁平数据构建成树形结构，并清理空的 children 字段
     * @param {Array} flatData - 扁平数据数组
     * @param {String} idField - 节点唯一标识字段名
     * @param {String} parentIdField - 父节点标识字段名
     * @returns {Array} 树形结构数组
     */
    buildTree(flatData, idField = 'id', parentIdField = 'parentId') {
      const map = {};
      const tree = [];

      // 构建映射关系
      flatData.forEach(item => {
        map[item[idField]] = { ...item, children: [] };
      });

      // 构建树结构
      flatData.forEach(item => {
        const id = item[idField];
        const parentId = item[parentIdField];

        if (parentId && map[parentId]) {
          map[parentId].children.push(map[id]);
        } else {
          tree.push(map[id]);
        }
      });

      // 清理空的 children 字段
      function removeEmptyChildren(node) {
        if (node.children && node.children.length === 0) {
          delete node.children;
        } else if (node.children) {
          node.children.forEach(removeEmptyChildren);
        }
      }

      tree.forEach(removeEmptyChildren);

      return tree;
    },
    //#endregion

    //#region right content
    //#region 拖动相关方法
    // 开始拖动
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startWidth = this.leftWidth;

      // 绑定鼠标移动和释放事件到document（避免鼠标移出手柄时失效）
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);

      // 防止拖动时选中文本
      e.preventDefault();
    },

    // 拖动中 - 使用requestAnimationFrame优化性能
    onDrag(e) {
      if (!this.isDragging) return;

      // 使用requestAnimationFrame优化性能
      if (!this.rafId) {
        this.rafId = requestAnimationFrame(() => {
          const newWidth = this.startWidth + (e.clientX - this.startX);

          // 限制最小和最大宽度
          if (newWidth >= this.minWidth && newWidth <= window.innerWidth - 700) {
            this.leftWidth = newWidth;
          }

          this.rafId = null;
        });
      }
    },

    // 结束拖动
    stopDrag() {
      this.isDragging = false;

      // 移除事件监听
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);

      // 取消动画帧
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    },

    // 更新最大宽度（响应窗口大小变化）
    updateMaxWidth() {
      this.maxWidth = window.innerWidth - 200;
    },

    //#endregion

    selectChange(data) {
      this.aaa.type = data;
      this.GetDataFileList();
    },
    GetFileLabel() {
      let params = { xid: localStorage.getItem("xid") }
      GetFileLabel({ params }).then(res => {
        if (res.Data)
          this.filelabelData = this.buildTree(res.Data, "id", "parentId")
      })
    },

    async documentOpen(item) {
      if (item.guid)
        AddRecentlyFile({ fileId: item.guid, userId: this.$store.state.uid, time: dayjs().format("YYYY-MM-DD HH:mm:ss") })
      let params = `fileId=${item.prfl01}&guid=${item.guid}&path=${item.prfl04}&xid=${item.prfl05}&name=${item.prfl02}`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewFileModel?Code=${params}`;
      window.open(url, "_blank");
    },
    async transformfilemodel(data) {
      data.modelstate = 0
      let res = await transformfilemodel(data);
      if (res.Code)
        this.$message({
          type: "success",
          message: this.$t('common.处理成功')
        })
      else
        this.$message({
          type: "error",
          message: this.$t('common.处理失败')
        })
      this.GetDataFileList()
    },



    //#endregion

    documentIcon(ext) {
      switch (ext) {
        case "png":
        case "jpg":
        case "jpeg":
        case "ico":
        case "gif":
        case "svg":
          return require('@/assets/img/图标/jpg.svg')
        case "dwg":
        case "dxf":
          return require('@/assets/img/图标/dwg.svg')
        case "mp4":
          return require('@/assets/img/图标/视频.svg')
        case "docx":
        case "doc":
          return require('@/assets/img/图标/doc.svg')
        case "xlsx":
        case "xls":
          return require('@/assets/img/图标/xls.svg')
        case "rvt":
        case "rfa":
          return require('@/assets/img/图标/rvt.svg')
        case "skp":
          return require('@/assets/img/图标/skp.svg')
        case "txt":
          return require('@/assets/img/图标/txt.svg')
        case "pdf":
          return require('@/assets/img/图标/pdf.svg')
        default:
          return require('@/assets/img/图标/文档.svg')
      }
    },

    documentIcon2(item) {
      let ext = item.ext
      switch (ext) {
        case "png":
        case "jpg":
        case "jpeg":
        case "ico":
        case "gif":
        case "svg":
          return this.$store.state.baseUrl + item.prfl04;
          return require('@/assets/img/图标/jpg.svg')
        case "dwg":
        case "dxf":
          return require('@/assets/img/图标/dwg.svg')
        case "mp4":
          return require('@/assets/img/图标/视频.svg')
        case "docx":
        case "doc":
          return require('@/assets/img/图标/doc.svg')
        case "xlsx":
        case "xls":
          return require('@/assets/img/图标/xls.svg')
        case "rvt":
        case "rfa":
          return require('@/assets/img/图标/rvt.svg')
        case "skp":
          return require('@/assets/img/图标/skp.svg')
        case "txt":
          return require('@/assets/img/图标/txt.svg')
        case "pdf":
          return require('@/assets/img/图标/pdf.svg')
        default:
          return require('@/assets/img/图标/文档.svg')
      }
    },

    GetDataFileList() {
      this.tableLoading = true;
      var labels = [];
      if (this.labelval.length > 0) {
        this.labelval.forEach(v => {
          labels.push(v.join("/"))
        })
        labels = labels.join(",")
      }
      let params2 = {
        seachword: this.query,
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        gid: this.gml ? "null" : this.selectNode.pftr01,
        type: this.aaa.type,
        labelval: labels,
        fileext: this.fileext.join(","),
        pageIndex: 1,
        pageSize: 99999,
      };
      GetDataFileList({ params: params2 }).then(res => {
        this.tableLoading = false;
        this.fileTableData = []
        if (this.folderData) {
          this.fileTableData = this.folderData;
        }
        if (res.Data.list && res.Data.list.length > 0) {
          res.Data.list = res.Data.list.filter(w => w.isHide == 0)
          res.Data.list.forEach(item => {
            item.editname = item.prfl02
          });
          this.fileTableData = this.fileTableData.concat(res.Data.list);
        }
        this.fileAllTableData = JSON.parse(JSON.stringify(this.fileTableData));
        this.handelSort()
      })
    },
    //#endregion


  },
  mounted() {



  },
  beforeDestroy() {
  }
};
</script>

<style lang="less" scoped>
/* 大图样式：固定定位 + 限制最大尺寸 */
.big-img {
  position: fixed;
  z-index: 9999;
  width: 600px;
  /* 固定宽度，避免加载后尺寸变化 */
  height: auto;
  /* 高度等比缩放 */
  // max-height: 400px;
  /* 最大高度限制 */
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  /* 禁用过渡动画，避免动画导致的频闪 */
  transition: none;
}

/deep/ .el-card__body {
  padding: 10px;
}

/* 若需要调整节点内容的内边距（可选） */
/deep/.el-tree-node__content {
  padding-top: 2px;
  /* 内容区域上边距 */
  padding-bottom: 2px;
  /* 内容区域下边距 */
}

/deep/.el-drawer__header {
  margin-bottom: 22px !important;
}

/deep/ .headerClass>th {
  background-color: rgb(247, 249, 255);
  border-bottom-color: rgb(235, 238, 245)
}

/deep/ .upload-dialog {
  position: absolute !important;
  ;
  right: 1% !important;
  bottom: 5% !important;
}

/deep/.el-dropdown-menu__item {
  color: black;
  background: #fff;

  &:hover {
    color: #ffbb37;
    background-color: black;
  }
}

/deep/ .el-dropdown-menu,
.el-popper,
.el-dropdown-menu--small {
  background-color: white !important;
}

/deep/ .popper__arrow::after {
  border-bottom-color: #FFFFFF !important;
}


/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: white !important;
  }
}


.el-dropdown-menu {
  background-color: #1f2d3d;
}

/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: rgb(25, 36, 49);
  }
}

.resizable-container {
  display: flex;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.left-panel {
  height: 100%;
  background-color: #f8f9fa;
  padding: 20px;
  overflow: auto;
  min-width: 200px;
  transition: none;
  /* 移除过渡效果，避免拖动时卡顿 */
}

.right-panel {
  flex: 1;
  height: 100%;
  background-color: #ffffff;
  padding: 20px;
  overflow: hidden;
}

.resizer {
  width: 8px;
  height: 100%;
  background-color: #e9ecef;
  cursor: col-resize;
  user-select: none;
  position: relative;
  z-index: 10;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resizer:hover,
.resizer.active {
  background-color: #4dabf7;
}

.resizer-handle {
  width: 4px;
  height: 60px;
  background-color: #adb5bd;
  border-radius: 2px;
  transition: background-color 0.2s;
}

.resizer:hover .resizer-handle,
.resizer.active .resizer-handle {
  background-color: #fff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .resizable-container {
    height: 500px;
  }

}
</style>